import { useState, useEffect } from "react";
import { X } from "lucide-react";

const notices = [
  "Demo data only",
  "Not a database of culture",
  "Does not replace Aboriginal authority",
  "Does not replace legal advice",
  "Background IP notice in effect",
  "Build privately before publishing",
];

export default function ProtectiveBanner() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const v = sessionStorage.getItem("bgb_banner_hidden");
    if (v === "1") setHidden(true);
  }, []);

  if (hidden) return null;

  return (
    <div
      className="sticky top-0 z-50 bg-[#9C4221]/[0.08] text-stone-800 border-b border-[#9C4221]/25"
      data-testid="protective-banner"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-2 flex items-center gap-4 overflow-hidden">
        <span className="shrink-0 text-[10px] tracking-[0.28em] uppercase font-bold text-[#9C4221]">
          Notice
        </span>
        <div className="relative overflow-hidden flex-1">
          <div className="flex gap-8 whitespace-nowrap animate-[scroll_38s_linear_infinite]">
            {[...notices, ...notices].map((n, i) => (
              <span key={`${n}-${i < notices.length ? 'a' : 'b'}`} className="text-[11px] tracking-wide text-stone-700">
                · {n}
              </span>
            ))}
          </div>
        </div>
        <button
          onClick={() => {
            sessionStorage.setItem("bgb_banner_hidden", "1");
            setHidden(true);
          }}
          data-testid="protective-banner-close"
          className="shrink-0 text-stone-500 hover:text-stone-900"
          aria-label="Dismiss notice"
        >
          <X className="h-3.5 w-3.5" />
        </button>
      </div>
      <style>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
